<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Martin vicencio -- .- .-. - .. -. / ...- .. -.-. . -. -.-. .. ---
  Author URL: http://
========================================================================================== -->

<template>
<!-- flex-centered -->
  <div class="flex-centered " v-if="hay_referencia==1 && esta_pagado==1 && renovar_seguro==2">
      <div v-if="liberar_carga!=1">      
       <div>
          <vx-card>
             <h3>
                 Recuerda que debes seleccionar las materias correspondientes a tu cuatrimestre siguiente,
                 revisa tu plan de estudios: 
                 <span v-if="id_carrera==1"> 
                   <a style="color:blue;" href="https://upbicentenario.edu.mx/ingenieria-en-agrotecnologia/" target="_blank">Ingeniería en Agrotecnología.</a>
                 </span>
                 <span v-else-if="id_carrera==2">
                    <a style="color:blue;" href="https://upbicentenario.edu.mx/ingenieria-en-diseno-industrial/" target="_blank">Ingeniería en Diseño Industrial. </a>

                 </span>
                     <span  v-else-if="id_carrera==3">
                    <a style="color:blue;" href="https://upbicentenario.edu.mx/ingenieria-en-logistica-y-transporte-oferta/" target="_blank">Ingeniería en Logística y Transporte.</a>

                 </span>
                     <span v-else-if="id_carrera==4">
                    <a style="color:blue;" href="https://upbicentenario.edu.mx/ingenieria-robotica-oferta/" target="_blank">Ingeniería Robótica.</a>

                 </span>

                     <span v-else-if="id_carrera==5">
                    <a style="color:blue;" href="https://upbicentenario.edu.mx/ingenieria-biomedica/" target="_blank">Ingeniería Biomédica.</a>

                 </span>
                     <span v-else>
                    <a style="color:blue;" href="https://upbicentenario.edu.mx/ingenieria-financiera/" target="_blank">Ingeniería Financiera.</a>
                 </span> 
               <br>  <a style="color:blue;" href="https://upbicentenario.edu.mx/horarios-de-grupos/" target="_blank"> Consultar horarios de grupos.</a>
               <br>
                  Cualquier duda acudir con tu Tutor de Grupo.
            <br> 

<!-- 
                Seleccione las materias a cargar para el Cuatrimestre: 
               <b>{{cuatrimestre_siguiente[0].nombre}} {{cuatrimestre_siguiente[0].idAgno}} </b> -->
          
               </h3>
          
                    <div class="invoice__invoice-detail mt-6">
                        <h5> Matrícula: <b>{{matricula}}</b>  <br>
                        Nombre del alumno(a): <b>{{alumno_detalle2['ncompleto']}}  </b>    
                        </h5>
                    
                       <h4><b>Nota importante: </b> <br> 
                        Total de materias curriculares a cargar hasta un máximo de 8 más un grupo de Tutoría (OBLIGATORIO).
                        <br>    <br>
                      
                       <!-- <b> Para las materias en calidad de recurse(2da. Oportunidad): </b><br> 
                        Una vez realizada tu carga academica de materias ordinarias (1ra. oportunidad) y que hayas realizado tus pagos(Re-inscripción, recurse de materias), acudir al Depto. de Control Escolar <br> 
                        con los comprobantes para la asignación de tus materias de recurse.
                         -->
                       </h4> 
              <br>         
                <h3>
                                  Seleccione las materias a cargar para el Cuatrimestre: 
                                      <b>{{cuatrimestre_siguiente[0].nombre}} {{cuatrimestre_siguiente[0].idAgno}} </b>
          
                 </h3>
        


                    </div>

  
<!-- <mark> -->
          <vs-table class="table" search pagination :maxItems="9" stripe :data="materias_curriculares">
            <template slot="thead">
              <vs-th scope="col">Número</vs-th>
              <vs-th scope="col">Clave(Id)</vs-th>
              <vs-th scope="col">Grupo</vs-th>
              <vs-th scope="col">Siglas</vs-th>
              <vs-th scope="col">Materia</vs-th>
              <vs-th scope="col">Profesor</vs-th>
              <vs-th scope="col">Cupo</vs-th>
             
              <vs-th scope="col">Horario disponible del Grupo</vs-th>
              

              <vs-th scope="col">Total de Alumnos en grupo</vs-th>
              <vs-th scope="col">Materia para recursar</vs-th>
              <vs-th scope="col">Pre-requisito</vs-th>
              <vs-th scope="col">Calificación</vs-th>
              <vs-th scope="col">Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
    <!-- <vs-tr :state="data[indextr].cuenta_con_pre_requisito == 0 ? 'success' :data[indextr].cuenta_con_pre_requisito != 0 ? 'danger':null" :key="indextr" v-for="(tr, indextr) in data" > -->
                   <!-- :state="data[indextr].cuenta_con_pre_requisito == 0 ? 'success':null" -->
              <vs-tr  v-show="data[indextr].cuenta_con_pre_requisito == 0 || data[indextr].calificacion >= 7" :key="indextr" v-for="(tr, indextr) in data" >
                      <!-- <vs-tr  :key="indextr" v-for="(tr, indextr) in data" > -->

                <vs-td :data="data[indextr].id">
                  {{indextr+1}}
                </vs-td>
                   <vs-td :data="data[indextr].id">
                  {{data[indextr].clave}}
                </vs-td>
                <vs-td :data="data[indextr].id">
                  {{data[indextr].carrera}}  {{data[indextr].idCuatrimestre}} {{data[indextr].digito}}
                </vs-td>
                <vs-td :data="data[indextr].id">
                  {{data[indextr].sigla}}

                </vs-td>    
                <vs-td :data="data[indextr].materia">
                    <!-- {{data[indextr].idMateria}} -->
                  <!-- 217 -->
                  {{data[indextr].materia}}

                </vs-td>             
               <vs-td :data="data[indextr].ncompleto">
                  {{data[indextr].ncompleto}}
                </vs-td>            
                 <vs-td :data="data[indextr].cupo">
                  {{data[indextr].cupo}}
                </vs-td>

                <vs-td :data="data[indextr].id" >

                  <!-- horario: <br>   style="display:none;" onclick="document.getElementById('btn_ver_h').style.display = 'block'" -->
                  <div v-if="data[indextr].horario_grupo!=''">
                  
                        <vs-button color="green" @click="ver_horario_grupo(data[indextr].horario_grupo,data[indextr].clave,data[indextr].materia)"> Ver Horario  </vs-button> 
<!--                     
                       <span id="btn_ver_h" class="badge bg-info text-dark" > 
                      {{data[indextr].horario_grupo}}. 
                      </span>  -->
                  </div>
                  <div v-else>
                     <span class="badge bg-danger text-dark"> aun no se han creado los horarios de este grupo</span> 
                  </div>
                  

                </vs-td>
          
                 <vs-td >
                       {{data[indextr].totalAlumnosEnGrupo}}
                       <!-- {{data[indextr].cupo}} -->
                       <!-- v-show="error_agregar_matricula !== '' -->

                       <div  v-if="data[indextr].totalAlumnosEnGrupo == data[indextr].cupo "> 
                            <span class="badge bg-warning text-dark">Cupo lleno</span></div>
                       <div v-else>
                        <span class="badge bg-success text-dark">Disponible</span> 
                        <!-- <span v-show=" data[indextr].totalAlumnosEnGrupo == data[indextr].cupo " class="badge bg-warning text-dark">Cupo lleno</span>  -->
                        </div>
                </vs-td>

                <vs-td :data="data[indextr].id">
               
                    
                     <span v-show="data[indextr].num_recurses>0" >
                
                         
                                  <!-- <vs-button @click="generar_referencia_recurse()"  color="warning"> -->
                                        <!-- {{ data[indextr].num_recurses }}  -->
                                        <span style="font-size: 16px;text-align: center;" class="badge bg-danger text-dark">
                                          SI
                                        </span>
                                      
                                       <!-- </vs-button> -->
                           
                    </span>

                </vs-td>
                <vs-td :data="data[indextr].id">
                   {{data[indextr].materia_pre}}
                </vs-td>
                <vs-td :data="data[indextr].id">
                  {{data[indextr].calificacion}}
                
                </vs-td>

                <vs-td style="text-align: center;" :data="data[indextr].id">
                    
                <!-- <div v-if="data[indextr].cuenta_con_pre_requisito !=0" >   -->

                 
                 <div v-if="data[indextr].calificacion !=null" >  
                       <div v-if="data[indextr].calificacion >= 7 " > 
                     
                            <div  v-if="data[indextr].totalAlumnosEnGrupo == data[indextr].cupo "> 
                              <!-- <span class="badge bg-warning text-dark">Cupo lleno</span> -->
                              </div>
                            <div v-else>

                           
                              <!-- {{data[indextr].cuenta_con_pre_requisito}} -->

                              <div v-if="data[indextr].cuenta_con_pre_requisito !=0" >   
                                 <!-- <span v-show="data[indextr].num_recurses<1">  -->
                                  <vs-button v-if="total_cargadas < 9 && data[indextr].horario_grupo!='' " @click="agregar_alumno_grupo(data[indextr].clave)" >
                                  Cargar 
                             <!-- 1 -->
                                   </vs-button> 
                             <!-- </span> -->
                              </div>



                            </div>                     

                       </div>
                  </div>
                     <div v-else>  

                         <div  v-if="data[indextr].totalAlumnosEnGrupo == data[indextr].cupo "> 
                              <!-- <span class="badge bg-warning text-dark">Cupo lleno</span> -->
                              </div>
                            <div v-else>
                        
                               <!-- No esta seriada la materia -->
                                <!-- {{data[indextr].cuenta_con_pre_requisito}} -->

                              <div v-if="data[indextr].cuenta_con_pre_requisito == 0 " > 
                                  <!-- <span v-show="data[indextr].num_recurses<1"> -->
                                 <vs-button v-if="total_cargadas < 9 && data[indextr].horario_grupo!=''  " @click="agregar_alumno_grupo(data[indextr].clave)" >
                                Cargar 
                                <!-- 2 -->
                               </vs-button> 
                               <!-- </span> -->
                              </div>
                              
                              </div>   

                            <!-- <vs-button v-if="total_cargadas < 9 " @click="agregar_alumno_grupo(data[indextr].clave)" > 
                          Cargar</vs-button>   -->


                     </div>


                <!-- </div> -->

                </vs-td>

                <!-- <vs-td>
                  hsajdkh
                </vs-td> -->
              </vs-tr>
            </template>
           </vs-table>
           </vx-card>
        </div> 

       </div>    <!-- liberar carga -->


         

          
            <vx-card title="">


             <div id="printContent">
             <h3> Materias cargadas para el Cuatrimestre: <b> {{cuatrimestre_siguiente[0].nombre}} {{cuatrimestre_siguiente[0].idAgno}} </b> </h3>
                       
            <br>

              <h3> Total de materias cargadas {{total_cargadas}}/9</h3>

              
                <div class="invoice__invoice-detail mt-6">
                        <h5> Matrícula: <b>{{matricula}}</b>  <br>
                        Nombre del alumno(a): <b>{{alumno_detalle2['ncompleto']}}  </b>    
                        </h5>
                    </div>         
           
            
            <vs-table  class="table" pagination :maxItems="9" stripe :data="materias_cargadas">
            
              <template slot="thead">
               <vs-th>Número</vs-th>
               <vs-th>Clave(Id)</vs-th>
               <vs-th>Grupo</vs-th>
               <vs-th>Sigla</vs-th>
               <vs-th>Materia</vs-th>
               <vs-th>Profesor</vs-th>
               <vs-th v-if="liberar_carga!=1">Acciones</vs-th>
              </template>
            
             <template slot-scope="{data}">
               <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].id">
                  {{indextr+1}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                   {{data[indextr].id}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                   {{data[indextr].grupo_carrera}} {{data[indextr].cuatrimestre}}  {{data[indextr].digito}} 
                  </vs-td>
                <vs-td :data="data[indextr].id">
                     {{data[indextr].sigla}}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    <div v-if="data[indextr].idMateria==217" style="display: none">{{ id_tutoria=data[indextr].idMateria}}</div>
                   {{data[indextr].materia}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                     {{data[indextr].profesor}}
                   </vs-td>
                  <vs-td :data="data[indextr].id" v-if="liberar_carga!=1">
                      <!-- {{data[indextr].id_alumnoGrupo}} -->
                   <!-- <vs-button class="" color="danger" v-if="data[indextr].calificacion"  @click="openConfirm(data[indextr].idfg)">Descargar</vs-button> -->
                   <vs-button class="" color="danger" v-if="liberar_carga!=1" @click="openConfirm(data[indextr].id_alumnoGrupo)" >Descargar</vs-button>
                </vs-td > 
               </vs-tr>
             </template>
            </vs-table>
        
           </div> <!-- </div>div area impresion -->

                <div  style="text-align: center;"> 
                      <div v-if="liberar_carga!=1"> 
                         <vs-button title="Nota: Una vez que guardes no podrás realizar ningún cambio."  color="primary" style="margin-left: 60px;" @click="guardar_carga()" >Guardar Carga</vs-button>
         
           
             <!-- <div style="text-align: left;">  
              <br> <br> <br>       
             <h4> <b> Nota Importante: </b> </h4>
              Una vez que hayas realizado y guardado la carga de materias(1ra. oportunidad y/o ordinarias), No podra editarse hasta la fecha de descarga de asignaturas, <a href="/alumnos/calendarioescolar/" target="_blank" rel="noopener noreferrer">
              ver Calendario Escolar vigente.</a> 
            </div> -->

           <div style="text-align: left;">  
              <br>    
             <h3> <b> Nota Importante: </b> <br>
              Una vez que hayas realizado y guardado la carga de materias(1ra. oportunidad y/o ordinarias), No podra editarse hasta la fecha de descarga de asignaturas, <a href="/alumnos/calendarioescolar/" target="_blank" rel="noopener noreferrer">
              ver Calendario Escolar vigente.</a> 
             </h3>
            </div>

             
            


                       </div>
                        <div  v-else>

                          <center>
                            <span><b> Imprimir Acuse de Carga Académica </b></span>
                              <vs-button style="padding: 30px;" color="primary" icon-pack="feather" title="Imprimir Carga de Materias Guardada"  icon="icon-printer" size="45px" @click="printpage()"></vs-button>
                            </center>

                            <br>
                    
                       <center>
                           <a href="/alumnos/horario/" target="_blank" rel="noopener noreferrer">
                        <span><b> Ver tu Horario de clases </b></span>
                            
                    
                                <img style="padding-left:25px;" src="@/assets/images/pages/horarioAlumo.jpg" alt="" title="Ver Horario da clic aquí" srcset="" width="8%" height="8%">
                                </a>
                                </center>
                                <br>
                         


                        </div>
                        <br>
               </div>



        <vs-popup style="" class="holamundo"  title="Horario de Grupo:" :active.sync="popupActivePago">
                  Clave del Grupo: {{clave2}} - Nombre de la Materia: {{materia2}}         
         <div class="p-3 mb-2 bg-info text-white" style="margin: 5px; textalign: justify; font-size:16px;  overflow-y: scroll; border:1px solid gray;  overflow-wrap: break-word;" > 
               Horario Disponible: {{vhg}}.    
          </div> 
          
        </vs-popup>

         </vx-card>
       
        
  </div> <!--div de hay referencia de pago width: 500px;  height: 200px; -->
  <div v-else>
       <vx-card>
      <h3> <mark>  ¡No se ha verificado su pago! </mark></h3>
    </vx-card>
    </div>



</template>

<script>
    import AddNewDataSidebar from './AddNewDataSidebar.vue';
    import vSelect from 'vue-select'
    import Button from "../components/vuesax/button/Button";
import { ExtendOptions } from 'vee-validate';
    export default {

        components: {
            Button,
            AddNewDataSidebar,
            'v-select': vSelect,
        },

        data() {
            return {
                matricula: localStorage.getItem('matricula'),
                id: localStorage.getItem('id'),
                id_alu: localStorage.getItem('id'),
                id_carrera: localStorage.getItem('id_carrera'),
              cuatrimestre_siguiente: [{ nombre: "", idAgno: "" }],
              cuatrimestre_actual: [{ nombre: "", idAgno: "" }],
                alumno_detalle: [],
              materias_curriculares: [],
              materias_cargadas: [],
              num_recurses:{},
              total_cargadas:[],
                selected: [],
                verifica_pago : 0,
                users: [],
                cargo_materias : 0,
                verifica_regular: 0,
                carga_actual: [],
                itemsPerPage: 200,
                isMounted: false,
                addNewDataSidebar: false,
                 referencias:[],
                  hay_referencia:'',
                  esta_pagado:'',
                  liberar_carga:'',
                cuatrimestreAlumno:{},
                id_re_inscripcion2:'',
                id_tutoria:'',
                 alumno_detalle2: [],
                 renovar_seguro:'',
                // varcupo:''
                  popupActivePago:false,
                  vhg:[],
                  materia2:'',
                  clave2:''
            }
        },

    computed: {

    },

    methods: {


ver_horario_grupo(var_horario_grupo,clave,materia){

     this.popupActivePago = true;
     console.log(var_horario_grupo);
     this.vhg=var_horario_grupo;
     this.clave2=clave;
     this.materia2=materia;



},

generar_referencia_recurse(){

 let text ="Estás seguro de que quieres realizar el pago de recurse de materia!";
          if(confirm(text) == true){
                 alert("pagina de referencias");

          
                  }else {
                  text = "Operación Cancelada!";
                 } 


},
          getAlumno() {
            this.$http.get("alumno_id/" + this.id).then(
                response => {
                    this.alumno_detalle2 = response.data.alumno;
                },
                error => { this.StepError(error); }
            );
          },


           printpage(){
                    
              let newstr = document.getElementById("printContent").innerHTML;
              let oldstr = document.body.innerHTML;
              document.body.innerHTML = newstr;
              // scale(0.85);
              window.print();
              // window.printPreview();
              document.body.innerHTML = oldstr;
              location.reload()
              return false;
              // location.reload()
              // window.print();
        
            },

    // getRecurses(idMateria){
    //         this.$http.get("get_recurses/"+this.id+"/"+idMateria).then(
    //             response => {
    //               this.num_recurses = response.data;              
    //             },
    //             error => {
    //               this.StepError(error);
    //             }
    //         );
    //          return this.num_recurses;
    //       },

    getCuatrimestreSiguiente(){
            this.$http.get("cuatrimestre_siguiente").then(
                response => {
                  this.cuatrimestre_siguiente = response.data.cuatrimestre_siguiente;
                 
                  //coloque el getreferencias para que trajera las del periodo y año del cuatrimestre actual
                  this.getReferencias();   
                 this.cuatrimestre_actual_alumno();
                   this.traer_carga();
                //  this.getMaterias();
                },
                error => {
                  this.StepError(error);
                }
            );

          },
  getReferencias() {
    // console.log(this.cuatrimestre_siguiente[0].idPeriodo);
      this.$http.get("get_referencias_bancomer_reinscripcion/" + this.id+"/"+this.cuatrimestre_siguiente[0].idAgno+"/"+this.cuatrimestre_siguiente[0].idPeriodo).then(
          response => {
            // console.log(referencias.data)
            this.referencias = response.data.ult_referencia_reinscripcion;
            this.liberar_carga=response.data.ult_referencia_reinscripcion[0].liberar_carga; 
            this.id_re_inscripcion2=response.data.ult_referencia_reinscripcion[0].id_re_inscripcion; 
            this.esta_pagado=response.data.ult_referencia_reinscripcion[0].pagado;
              this.renovar_seguro = response.data.renovar_seguro;
            // console.log(this.renovar_seguro);
             this.hay_referencia=this.referencias.length;   //cuenta si  trae alguna referencia
              // console.log(response.data.ult_referencia_reinscripcion[0].pagado);
          },
          error => {
            this.StepError(error);
          }
      );
    },

    agregar_alumno_grupo(claveGrupo){

        let text ="Estás seguro de que quieres cargar esta materia!";
          if(confirm(text) == true){
            
              let tokenStorage=localStorage.getItem('app-token');
              this.$http.post("agregar_alumno_grupo",{token:tokenStorage,id:this.id,claveGrupo:claveGrupo,idAgno:this.cuatrimestre_siguiente[0].idAgno,idPeriodo:this.cuatrimestre_siguiente[0].idPeriodo}).then(
                    
                        response => {
                       
                            if(response.data.status ==2){ 
                                
                                        this.$vs.notify({
                                          color: 'success',
                                          title: 'Materia Cargada',
                                          text: 'Se ha cargado correctamente'
                                        })
                                          this.traer_carga();
                                          this.getMaterias();
                            }else if(response.data.status ==3){
                                       this.$vs.notify({
                                        time: 3000,
                                        title: 'Nota-',
                                        text: '¡Ya existe una materia cargada para ese horario!',
                                        iconPack: 'feather',
                                        icon: 'icon-alert-circle',
                                        color: 'danger'
                                        });
                    
                              }else{
                    
                                         this.$vs.notify({
                                          color: 'danger',
                                          title: 'La materia ya fue cargada',
                                         // text: response.data.status Este alumno ya esta agregado al grupo
                                         text: 'Ya has cargado esa materia'
                                        });
                                }

                            
                        },
                        error => {
                            if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
                            this.$router.push({name:'pageLogin'});
                            localStorage.clear();
                            location.reload()
                            }
                            this.StepError(error);
                        }
                    );

                     }else {
                  text = "Operación Cancelada!";
                 } 

          },

          openConfirm(grupo){
            localStorage.setItem("grupo_a_quitar", grupo)
            this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Confirmar`,
              text: '¿Seguro que desea descargar la materia?',
              accept: this.acceptAlert
            })
          },
   
          acceptAlert() {
            this.$vs.notify({
              color: 'danger',
              title: 'Materia Descargada',
              text: 'La materia se ha descargado correctamente'
            })
            this.$http.get("quitar_alumnoGrupo/" + localStorage.getItem("grupo_a_quitar") ).then(
                response => {

                  this.getMaterias();
                  this.traer_carga();
                  
                },
                error => {  this.StepError(error);  }
            );
             

          },


        guardar_carga(){
                let text ="Estas seguro que quieres guardar la carga!";
                // console.log(this.id_tutoria);
                 if(this.id_tutoria == 217){
          if(confirm(text) == true){
                
               this.$http.get("guardar_carga_alumno/"+this.id+"/"+this.id_re_inscripcion2).then(
                          response => {

                          if(response.data.status ==1){
                                     this.$vs.notify({
                                          color: 'success',
                                          title: 'Carga de Materias',
                                          text: 'Se ha guardado correctamente'
                                         //  text: response.data.status
                                        })
                                          // this.traer_carga();
                                          location.reload();
                            }

                          },
                          error => {this.StepError(error); }
                        );

                 }else {
                  text = "Operación Cancelada!";
                 } 
              }else {
                  text = "Te falta agregar Tutoria!";
                  alert(text);
                 } 
          },
       

          // getCuatrimestreActual(){
          //   this.$http.get("cuatrimestre_actual").then(
          //       response => {
          //         this.cuatrimestre_actual = response.data.cuatrimestre_actual;
          //         this.verificar_pago();
          //       },
          //       error => { this.StepError(error); }
          //   );
          // },

            // verifica_regular_fn(){
            //   this.$http.get("verificar_regular/" + this.id + "/" + this.cuatrimestre_actual[0].idAgno + '/' + this.cuatrimestre_actual[0].idPeriodo).then(
            //             response => {
            //                   this.verifica_regular = response.data
            //               if( this.verifica_regular == 1){
            //                 }
            //             },
            //             error => {this.StepError(error); }
            //         );
            // },

            // verificar_pago(){
            //     this.$http.get("verificar_pago/" + this.id + "/" + this.cuatrimestre_siguiente[0].idAgno + '/' + this.cuatrimestre_siguiente[0].idPeriodo).then(
            //         response => {
            //           this.verifica_pago = response.data;
            //           this.verifica_regular_fn();
            //         },
            //         error => {
            //             this.StepError(error);
            //         }
            //     );
            // },

          traer_carga(){
            // materias_cargadas
             this.$http.get("get_carga_periodo/" + this.id+ "/" + this.cuatrimestre_siguiente[0].idAgno + "/" + this.cuatrimestre_siguiente[0].idPeriodo).then(
           response => {
                         this.materias_cargadas = response.data.carga;
                         this.total_cargadas= Object.keys(response.data.carga).length;
                        //  if(total_cargadas > 9){
                        //   alert("El maximo de materias a cargar son 8");
                        //  }else{}

                    },
                    error => { this.StepError(error); }
              );

            },

        // validar_carga(){
        //         this.$http.post('enviar_carga_siguiente', {
        //             idAlumno: this.id,
        //             materias: this.selected,
        //         })
        //             .then(response => {
        //               if(response.data == "Se han cargado sus materias correctamente"){
        //                     this.cargo_materias = 1;
        //                     this.traer_carga();
        //               }
        //             }, error => {this.StepError(error);}
        //          );
        //     },
            
      // funcion que sirve para sacar el cuatrimestre del alumno 
        cuatrimestre_actual_alumno(){
             this.$http.get("cuatrimestre_actual_alumno/"+this.id).then(
                response => {
                  this.cuatrimestreAlumno = response.data.cuatrimestre_act_alumno;
                  this.getMaterias();
                },
                error => {
                  this.StepError(error);
                }
            );
          },

    getMaterias() {
       var cuatri=this.cuatrimestreAlumno.length+1;                                    
    this.$http.get("get_materias_curriculares/" + this.id+ "/" + this.cuatrimestre_siguiente[0].idAgno + "/" + this.cuatrimestre_siguiente[0].idPeriodo+ "/"+ this.id_carrera+"/"+cuatri).then(
           response => {
                         this.materias_curriculares = response.data.materias;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
        },

    },
        
// creado
  created() {
           this.getAlumno();
            this.getCuatrimestreSiguiente();
        },
// montado
      mounted() {
      
         //   this.isMounted = true;
           // this.verifica_regular_fn();
        },

    }
</script>

<style lang="scss">
    #data-list-list-view {
        .vs-con-table {

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;
                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search{
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        &+i {
                            left: 1rem;
                        }

                        &:focus+i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr{
                    box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
                    td{
                        padding: 20px;
                        &:first-child{
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }
                        &:last-child{
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }
                    td.td-check{
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead{
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text{
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }
                th.td-check{
                    padding: 0 15px !important;
                }
                tr{
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
